import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { string, shape, arrayOf } from 'prop-types';
import { Grid, Typography, Box } from '@material-ui/core';
import FaqItem from './FaqItem';
import styles from './index.styles';
import useGetCurrentPath from '../../../../hooks/useGetCurrentPath';
import Container from '../../Container';
const useStyles = makeStyles(styles);

const Faq = ({ title, questions }) => {
  const { currentPath } = useGetCurrentPath();
  const largeTopMargin = currentPath === '/contact';
  const classes = useStyles({ largeTopMargin });
  return (
    <Grid
      container
      direction="column"
      className={classes.faqContainer}
      alignItems="center"
    >
      <Typography variant="h2" className={classes.title}>
        {title}
      </Typography>
      <Container>
        <Grid
          container
          item
          className={classes.accordionContainer}
        >
          {questions.map(
            ({ question, answer: { answer } }, index) => {
              return (
                <FaqItem
                  key={question}
                  question={question}
                  answer={answer}
                  faqNumber={index + 1}
                />
              );
            }
          )}
        </Grid>
      </Container>
      <Box
        className={`${classes.basePattern} ${classes.topRightPattern}`}
      />
      <Box
        className={`${classes.basePattern} ${classes.bottomLeftPattern}`}
      />
    </Grid>
  );
};

Faq.propTypes = {
  title: string,
  questions: arrayOf(
    shape({
      question: string,
      answer: shape({
        answer: string,
      }),
    })
  ),
};

export default Faq;
